import get from 'lodash.get';
import { OrderPayment } from '~app/modules/checkout/models';
import { ITotal } from '~shared/modules/cart/models';
import { GaTrackingHelpersService } from '~shared/modules/ga-tracking/utils/ga-tracking-helpers.service';
import { CartOfferLine } from '~shared/modules/shopping-cart-store';
import { GaTrackingEventName, GATrackingEventType, GaTrackingStringConstantEnum } from '../../constants';
import { GATrackingEventPayload } from '../ga-tracking-event-payload.model';
import { GATrackingEvent } from '../ga-tracking-event.model';
import { GaTrackingCheckoutService } from '~shared/modules/ga-tracking/utils/ga-tracking-checkout.service';

export class GATrackingPurchaseEvent implements GATrackingEvent {

  constructor(
    protected offerLines: CartOfferLine[],
    protected totals: ITotal,
    protected orderPayment: OrderPayment,
    protected priceType: string,
  ) {
  }

  getEventType(): GATrackingEventType {
    return GATrackingEventType.Purchase;
  }

  getPayload(): GATrackingEventPayload {
    const products = [];

    this.offerLines.forEach((offer: CartOfferLine) => {
      const categoryTree = get(offer, 'trackingData.categoryTree', '') || [];
      const dimension29 = GaTrackingHelpersService.getReferencePriceTypeFromOffer(offer);
      const dimension31 = get(offer, 'trackingData.dimension31', 0);
      const recommendation = get(offer, 'trackingData.recommendation') ?
        GaTrackingStringConstantEnum.Yes : GaTrackingStringConstantEnum.No;
      const vasData = GaTrackingHelpersService.getVasRelatedDataFromOffer(offer);

      products.push({                                               // List of productFieldObjects.
        'name': get(offer, 'item.name'),                            // Name or ID is required.
        'id': get(offer, 'item.id'),
        'price': get(offer, 'price.offer'),
        'brand': get(offer, 'seller.name'),
        'category': categoryTree?.map((tree) => get(tree, 'name', ''))?.join('/') ?? "",
        'category_id': get(offer, 'trackingData.leafCategoryId', ''),
        'quantity': get(offer, 'quantity'),
        'coupon': '',
        'dimension42': get(offer, 'trackingData.dimension42', 0),
        'dimension27': get(offer, 'trackingData.offerType', 'other'),
        'dimension14': get(offer, 'trackingData.volumePricingShown', 'No'),
        'dimension22': get(offer, 'trackingData.otherOffersShown', 'No'),
        'dimension12': get(offer, 'trackingData.onSale', false),
        'dimension15': get(offer, 'trackingData.sellerName', ''),
        'dimension32': get(
          offer,
          'trackingData.EECLabel',
          GaTrackingStringConstantEnum.NoEECLabel
        ), // Optional fields may be omitted.
        'dimension33': recommendation,
        'dimension43': get(offer, 'trackingData.dimension43', 0),
        ...(!!dimension29 ? { dimension29 } : {}),
        ...(!!dimension31 ? { dimension31 } : {}),
        'dimension51': get(offer, 'trackingData.dimension51', GaTrackingStringConstantEnum.No),
        'dimension52': get(offer, 'trackingData.dimension52', GaTrackingStringConstantEnum.No),
        'dimension53': get(offer, 'trackingData.dimension53', GaTrackingStringConstantEnum.No),
        'dimension54': get(offer, 'trackingData.dimension54', ''),
        ...vasData
      });
    });

    const purchase = {
      ...GaTrackingCheckoutService.getAuthorizeFlow,
      price_type: this.priceType,
      shipping: +this.totals.shippingCostTotal,
      'ecommerce': {
        'purchase': {
          'actionField': {
            'id': get(this.orderPayment, 'payload.payment.orderId', ''),        // Transaction ID.
            'revenue': get(this.totals, 'total', 0),                // Total transaction value
            'tax': get(this.totals, 'subTotalTax', 0),
            'coupon': ''
          },
          products,
        }
      },
      'payment_date-of-birth': Boolean(get(this.orderPayment, 'payload.request.additionalInformation.dateOfBirth', ''))
    };

    return {
      event: GaTrackingEventName.Purchase,
      gtmCustom: purchase
    };
  }

}
